import { Card, Grid } from "@mui/material";
import CardItem from "components/alove/CardItem";
import ItemPageContainer from "layouts/itemPageContainer";
import { AISimulation } from "models/AISimulation";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createAISimulationDO, deleteAISimulationDO, executeAISimulation, getAISimulation, saveAISimulationDO } from "utils/AISimulationUtils";
import { addAlert, useMaterialUIController } from "context";
import { PermissionType } from "models/BO/BoRole";
import { SMEHeader } from "layouts/itemPageContainer/userItem/profileHeader";
import { PageNumber } from "accessNumbers";
import { AiSimulationForm } from "./components/AiSimulationForm";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
const DashboardNavbar = require("examples/Navbars/DashboardNavbar/index.js").default;
import { AISimulationMessages } from "./components/AISimulationMessages";
import { ItemHeader } from "layouts/itemPageContainer/userItem/itemHeader";
import { avatarUrl, formatDate } from "utils/globalsUtils";
import { AiSimulationHistory } from "./components/AiSimulationHistory";
import { Profile } from "models/profile/Profile";
import { getByEmailPhone, getByUserId } from "utils/enduserUtils";
import { EndUser } from "models/profile/EndUser";
import { Intros } from "layouts/endUsers/endUserIntroductions/compenents/intros";
import { AISimulationInsights } from "./components/AISimulationInsights";
export const AISimulationsView = () => {
  const pageNumber = PageNumber.ViewInfoScreen;
  const navigate = useNavigate();
  const [controller, dispatch] = useMaterialUIController();
  const { currentRole } = controller;
  const [userData, setUserData] = useState({} as EndUser);
  const [aiSimulation, setAISimulation] = useState({
    profileId: "b9675ef6-c13e-49a9-8051-706d8ce224bf"
  } as AISimulation);
  const { id } = useParams();

  useEffect(() => {
    _loadAISimulation();
  }, [id]);

  const _loadAISimulation = () => {
    if (id && id !== "new") {
      getAISimulation(id).then((AISimulation) => setAISimulationObject(AISimulation));
    }
  }

  useEffect(() => {
    if (aiSimulation.profileId) {
      getByUserId(aiSimulation.profileId).then((p) => {
        let { user, profile, profileAssets } = p;
          user ||= new EndUser();
        user.avatar = avatarUrl(profile.profileId, profileAssets?.[0]?.uri);


        setUserData(Object.assign(new EndUser(), user));
      });
    }
  }, [aiSimulation.profileId]);

  const setAISimulationObject = (newAISimulation) => {
    setAISimulation(Object.assign(new AISimulation(), newAISimulation));
  };

  const saveAISimulation = async () =>
    id === "new" ? createAISimulationDO(aiSimulation).then((aiSimulation) => navigate(-1)) : saveAISimulationDO(aiSimulation);

  const deleteAISimulation = async () => deleteAISimulationDO(aiSimulation).then(() => navigate(-1));

  const _executeAISimulation = async () => executeAISimulation(aiSimulation)
      .then(() => _loadAISimulation())
      .then(() => addAlert(dispatch, "AI Simulation executed successfully"));

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="AI Simulations" />
      <ItemPageContainer
        navItems={[
          { label: "Edit AI Simulation", ref: "AISimulation" },
          { label: "Messages", ref: "messages" },
          { label: "History", ref: "history" },
        ]}
        actions={{
          actionsTitle: "AI Simulation actions",
          itemName: `Information AI Simulation`,
          itemNumber: `#${aiSimulation.id}`,
          actions: [
            {
              title: "Save",
              onClick: saveAISimulation,
              variant: "contained",
            },
            {
              title: "Execute",
              onClick: _executeAISimulation,
              variant: "contained",
            }
          ],
        }}
        itemHeader={<SMEHeader
        formData={userData}
        navigateTo={() => open(`/#/endUsers/${aiSimulation.profileId}`, "_blank")}
          indications={[
            {
              title: "Model",
              value: aiSimulation.model || "GPT-3.5",
            },
            {
              title: "Executed At",
              value: formatDate(aiSimulation.executedAt)
            },
          ]} />}
        deleteItem={{
          buttonText: "Delete AI Simulation",
          contetnText: "Are you sure you want to delete this AI Simulation?",
          hidden: !currentRole.hasAccess(pageNumber, PermissionType.Delete),
          onDelete: deleteAISimulation,
        }}
      >
        <CardItem title="Information" id="AISimulation">
          <AiSimulationForm aiSimulation={aiSimulation} setAiSimulation={setAISimulation} />
        </CardItem>
        <CardItem title="Matches" id="matches">
          <Intros filter="matched" profileId={aiSimulation.profileId} name={userData.firstName || ""} />
        </CardItem>
        <CardItem title="Messages" id="messages">
          <AISimulationMessages aiSimulation={aiSimulation} setAiSimulation={setAISimulation} />
        </CardItem>
        <CardItem title="History" id="history">
          <AiSimulationHistory aiSimulation={aiSimulation} />
        </CardItem>
        <CardItem title="Insights" id="insights">
          <AISimulationInsights insights={aiSimulation.insights || []} />
        </CardItem>
        
      </ItemPageContainer>
    </DashboardLayout>
  );
};
